module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAQRJREFUaAXtmUEKAjEMRafuZHZ6Rw/gcdx6BZfewcOI6/oDFmQwXYSETMdfKIJhfvrfz2K008RFAiRAAiSQQKBE9ay1ztA+ffQvpZRXVK8wXZg4Yj+w27qFNYsSxskP2N8mxMwzql+IrmJCjFxDGkaIdkzcUdtH9HTXpAl3pEZBJmEE5/4Yk3BHahRkEkZw7o8xCXekRsGtJDHDyPItFl/Vcd6dJEAc+CynXqzVmth1pq52auOUkMQ2RkuQw8yvX3sybasdMXVUaEZFk1xgMskBqO2ZjIomucBkkgNQ2zMZFU1y4V+SGedP7DYQSjJjXSt0zIRf9PDqrdHnJwmQAAmQgIXAG+f8rKJZ3MaDAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/back.png
// module id = P9/e
// module chunks = 0